import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=2faa4974&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=2faa4974&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa4974",
  null
  
)

export default component.exports